import { _ } from 'vue-underscore';
import Vue from 'vue';
import api from "../utils/api.js";
import { OUTFIT_TYPES } from '../../config.js';

export const featuredOutfits = {
    namespaced: true,
    state: {
        featuredOutfits: [],
    },
    getters: {
        featuredOutfits(state) {
            return state.featuredOutfits;
        },
    },
    mutations: {
        setFeaturedOutfits(state, outfits) {
            state.featuredOutfits = outfits.map(outfit => ({
                ...outfit,
                currentProductIndex: 0,
                type: OUTFIT_TYPES.FEATURED,
            }));
        },
        changeOutfitProduct(state, payload) {
            const { index: productIndex, product, outfitId } = payload;
            const outfitIndex = state.featuredOutfits.findIndex(outfit => outfit.outfit_id === outfitId);
            const { products } = state.featuredOutfits[outfitIndex];

            products.splice(
                productIndex,
                1,
                product,
            );

            Vue.set(state.featuredOutfits[outfitIndex], 'products', products);
        },
        changeCurrentProduct(state, payload) {
            const { currentProductIndex, outfitId } = payload;
            let { outfitIndex } = payload;

            if (outfitIndex == undefined) outfitIndex = state.featuredOutfits.findIndex(outfit => outfit.outfit_id === outfitId);
            const outfitFromState = state.featuredOutfits[outfitIndex];

            state.featuredOutfits.splice(
                outfitIndex,
                1,
                {
                    ...outfitFromState,
                    currentProductIndex,
                },
            );
        },
    },
    actions: {
        fetchFeaturedOutfits(context, page = 0) {
            const uri = api.outfitsUri() + '/featured';
            const { optionValues: product_option_value_ids, pricePercentage: outfit_price_percentage, sort } = context.rootGetters['filters/selectedFilters'];
            let scrollToTop = false;
            return api
                .get(uri, {
                    params: {
                        product_option_value_ids,
                        limit: 20,
                        page,
                        sort_field_type: sort.type,
                        order: sort.order,
                        outfit_price_percentage,
                    }
                })
                .then(response => {
                    if (!_.isEqual(
                        context.state.featuredOutfits.slice(page * 20, page * 20 + 20).map(outfit => outfit.outfit_id),
                        response.outfits.map(outfit => outfit.outfit_id))
                    ) {
                        context.commit("setFeaturedOutfits",
                            [
                                ...context.state.featuredOutfits.slice(0, page * 20),
                                ...response.outfits,
                            ]
                        );
                        if (page === 0) {
                            scrollToTop = true;
                        }
                    }

                    return {
                        outfits: response.outfits,
                        scrollToTop,
                    };
                })
                .catch((err) => { throw err });
        },
        fetchFeaturedCollections(context, payload) {
            const uri = api.collectionsUri() + payload.collectionId + "/outfits";
            const { optionValues: product_option_value_ids, pricePercentage: outfit_price_percentage, sort } = context.rootGetters['filters/selectedFilters'];
            const page = payload.page;

            let scrollToTop = false;
            return api
                .get(uri, {
                    params: {
                        product_option_value_ids,
                        limit: 20,
                        page,
                        sort_field_type: sort.type,
                        order: sort.order,
                        outfit_price_percentage,
                    }
                })
                .then(response => {
                    if (!_.isEqual(
                        context.state.featuredOutfits.slice(page * 20, page * 20 + 20).map(outfit => outfit.outfit_id),
                        response.outfits.map(outfit => outfit.outfit_id))
                    ) {
                        context.commit("setFeaturedOutfits",
                            [
                                ...context.state.featuredOutfits.slice(0, page * 20),
                                ...response.outfits,
                            ]
                        );
                        if (page === 0) {
                            scrollToTop = true;
                        }
                    }

                    return {
                        outfits: response.outfits,
                        scrollToTop,
                    };
                })
                .catch((err) => { throw err });
        },
    },

};